export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/arrow-marketing.6f377d65-d5833b.svg";